'use strict';

import React, { useCallback, useEffect, useState } from 'react'

import RegistrationLegal from '@/Form/RegistrationLegal'
import getFormStatus     from '@/Form/Functions/getFormStatus'
import FormElement       from '@/Form/toolkit/FormElement'

import Loader from '@Pure/Loader'
import Link   from '@Pure/Link'

import bemit from '@function/bemit'

export default function RegistrationConfirmationForm ({ setStatus, onSubmit,
...props })
{
	const [form_data, setFormData] = useState({ });

	useEffect(function ()
	{
		if (!props.user) return;

		setFormData(
		{
			'user[login]': props.user.login,
			'user[firstname]': props.user.firstname,
			'user[lastname]': props.user.lastname,

			token: props.token
		});
	},
	[props.user, props.token]);

	const handleChange = useCallback(function (e, data)
	{
		setFormData(function (form_data)
		{
			return { ...form_data, [data.name]: data.value };
		});

		setStatus(function (status)
		{
			status.fields ||= { };

			status.fields[data.name] = { };

			return { ...status, info: undefined, error: undefined, warning: undefined };
		});
	},
	[setStatus]);

	const sendForm = useCallback(function (e)
	{
		onSubmit(e, form_data);
	},
	[form_data, onSubmit]);

	const loader = props.loading === true && props.user ?
	(
		<Loader className="c-loader" bemit={ ['white', 'bg-primary'] } />
	)
	: undefined;

	let imported_user_fields;

	if (props.user && props.user.permissions.title === 'Membre de CE')
	{
		imported_user_fields =
		(
			<>
				<div className="o-grid__item-12">
					<FormElement type="text" name="user[firstname]"
						label="Prénom" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status.fields }
						required
					/>
				</div>

				<div className="o-grid__item-12">
					<FormElement type="text" name="user[lastname]"
						label="Nom" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status.fields }
						required
					/>
				</div>

				{
					props.phone_required ?
					(
						<div className="o-grid__item-12">
							<FormElement type="text" name="user[phone]"
								label="Téléphone mobile" id_prefix="registration-form-"
								onChange={ handleChange } data={ form_data }
								status={ props.status.fields }
								placeholder=" Requis pour la carte Syner'Kado, commence par 06, 07, +33 ou +34"
								required
							/>
						</div>
					)
					: undefined
				}
			</>
		);
	}

	const submit_area = props.success !== true ?
	(
		<div className="c-btn-container c-btn-container--form
			u-margin-bottom-15">
			<button type="button"
				className="c-btn c-btn--primary c-btn--extra"
				onClick={ sendForm }>
				Je valide mon inscription
				{ loader }
			</button>
		</div>
	)
	: undefined;

	const fields = props.success !== true ?
	(
		<>
			<div className="o-grid-2">

				<div className="o-grid__item-12">
					<FormElement type="email" name="user[login]" label="E-mail"
						id_prefix="registration-form-" data={ form_data }
						onChange={ handleChange }
						status={ props.status.fields }
						readOnly={ true }
					/>
				</div>

			</div>

			<div className="o-grid-2 u-margin-top-10">

				{ imported_user_fields }

				<div className="o-grid__item">
					<FormElement type="password" name="user[password]"
						label="Mot de passe" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status.fields }
						required
					/>
				</div>

				<div className="o-grid__item">
					<FormElement type="password" name="user[password_confirmation]"
						label="Confirmation du mot de passe" id_prefix="registration-form-"
						onChange={ handleChange } data={ form_data }
						status={ props.status.fields }
						required
					/>
				</div>

			</div>

			<RegistrationLegal handleChange={ handleChange }
				form_data={ form_data }
				status={ props.status.fields }
			/>
		</>
	)
	: undefined;

	return (
		<div className={ props.className + ' form-registration' }>

			<div className="home-tabs">
				<div className="c-tab c-tab--active" style={ { width: '100%' } }>
					<h2 className="c-tab__label">Confirmation d'inscription</h2>
				</div>
			</div>

			<div className="form-registration__content">

				{ fields }

				<div className="o-content">
					{
						props.success ?
						(
							<div className={ bemit('c-form-message', ['green']) }
								style={ props.style }>
								<div className="c-form-message__content">
									Inscription effectuée. Vous pouvez maintenant vous connecter via le
									{ ' ' }
									<Link href="/login">
										formulaire de connexion
									</Link>
									.
								</div>
							</div>
						)
						: getFormStatus(props.status)
					}
					{ submit_area }
				</div>

			</div>

		</div>
	);
}